import FormSection from './FormSection'
import { translations } from '../../data/translations'

const MigrationSection = ({ formData, updateFormData, language }) => {
  const t = translations[language]?.migration || translations.de.migration

  const handleCheckboxChange = (field, value) => {
    const currentValues = formData[field] || []
    const newValues = currentValues.includes(value)
      ? currentValues.filter(v => v !== value)
      : [...currentValues, value]
    updateFormData(field, newValues)
  }

  return (
    <FormSection
      title={t.title}
      subtitle={t.subtitle}
    >
      {/* 13.1 Bestehende Website */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle1}</div>
        
        <div className="form-group">
          <label htmlFor="migration_url">{t.migrationUrl}</label>
          <input
            type="url"
            id="migration_url"
            name="migration_url"
            value={formData.migration_url || ''}
            onChange={(e) => updateFormData('migration_url', e.target.value)}
            placeholder="https://www.beispiel.de"
          />
        </div>

        <div className="form-group">
          <label>{t.migrationBenoetigt}</label>
          <div className="radio-group">
            {t.migrationOptionen.map(option => (
              <div key={option.value} className="radio-item">
                <input
                  type="radio"
                  id={`mig-${option.value}`}
                  name="migration_benoetigt"
                  value={option.value}
                  checked={formData.migration_benoetigt === option.value}
                  onChange={(e) => updateFormData('migration_benoetigt', e.target.value)}
                />
                <label htmlFor={`mig-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 13.2 Was soll migriert werden? */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle2}</div>
        
        <div className="checkbox-group" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))' }}>
          {t.migrationInhalteOptionen.map(option => (
            <div key={option.value} className="checkbox-item">
              <input
                type="checkbox"
                id={`mig-inh-${option.value}`}
                checked={(formData.migration_inhalte || []).includes(option.value)}
                onChange={() => handleCheckboxChange('migration_inhalte', option.value)}
              />
              <label htmlFor={`mig-inh-${option.value}`}>{option.label}</label>
            </div>
          ))}
        </div>
      </div>

      {/* 13.3 Aktuelle Plattform */}
      <div className="subsection">
        <div className="subsection-title">{t.subtitle3}</div>
        
        <div className="form-group">
          <label>{t.aktuellePlattform}</label>
          <div className="radio-group">
            {t.plattformOptionen.map(option => (
              <div key={option.value} className="radio-item">
                <input
                  type="radio"
                  id={`plat-${option.value}`}
                  name="aktuelle_plattform"
                  value={option.value}
                  checked={formData.aktuelle_plattform === option.value}
                  onChange={(e) => updateFormData('aktuelle_plattform', e.target.value)}
                />
                <label htmlFor={`plat-${option.value}`}>{option.label}</label>
              </div>
            ))}
          </div>
        </div>

        {formData.aktuelle_plattform === 'andere' && (
          <div className="form-group">
            <label htmlFor="plattform_andere_text">{t.plattformAndere}</label>
            <input
              type="text"
              id="plattform_andere_text"
              name="plattform_andere_text"
              value={formData.plattform_andere_text || ''}
              onChange={(e) => updateFormData('plattform_andere_text', e.target.value)}
              placeholder={t.plattformAnderePlaceholder}
            />
          </div>
        )}

        <div className="form-group">
          <label htmlFor="migration_notizen">{t.migrationNotizen}</label>
          <textarea
            id="migration_notizen"
            name="migration_notizen"
            value={formData.migration_notizen || ''}
            onChange={(e) => updateFormData('migration_notizen', e.target.value)}
            placeholder={t.migrationNotizenPlaceholder}
            rows="3"
          />
        </div>
      </div>
    </FormSection>
  )
}

export default MigrationSection
